import * as AppConstants from '../constants/AppConstants'

export const DEFAULT_BOOKING_STEPS = [
  AppConstants.BOOKING_STEP.CAR_INFO,
  AppConstants.BOOKING_STEP.SERVICE_INFO,
  AppConstants.BOOKING_STEP.DATE_LOCATION_INFO,
  AppConstants.BOOKING_STEP.CUSTOMER_INFO,
  AppConstants.BOOKING_STEP.REVIEW_INFO
]

export const AUDI_BOOKING_STEPS = [
  AppConstants.BOOKING_STEP.DATE_LOCATION_INFO,
  AppConstants.BOOKING_STEP.CUSTOMER_INFO,
  AppConstants.BOOKING_STEP.REVIEW_INFO
]



// WEBPACK FOOTER //
// ./src/configs/BookingStepsConfig.js